import React, { useEffect, useState } from 'react';
import TeachersInfo from './teachersInfo'
import { getTeachersProfile, getUser } from '../../../actions';
import jwt from 'jwt-decode';


const TeachersProfile = () => {
  const [user, setUser] = useState({});
  const [teacher, setTeacher] = useState();
  const [loading, setLoading] = useState(false);
  const [added, setAdded] = useState('')


  useEffect(() => {
    const t = localStorage.getItem('token');
    const persistedToken = jwt(t);
    if (persistedToken && persistedToken['nameid']) {
      setLoading(true);
      getUser(persistedToken['nameid']).then(res => {
        setUser(res.data);
        setLoading(false);
      });
    }

    getTeachersProfile().then(({ data }) =>
      setTeacher({
        ...data,
        classroomTeacher: data.advisingClass && data.advisingClass.year && data.advisingClass.letter ?
          (data.advisingClass.year + data.advisingClass.letter) : ''
      })
    )
  }, []);

  useEffect(() => {
    if (added) {
      setAdded(false);
      const t = localStorage.getItem('token');
      const persistedToken = jwt(t);
      if (persistedToken && persistedToken['nameid']) {
        setLoading(true);
        getUser(persistedToken['nameid']).then(res => {
          setUser(res.data);
          setLoading(false);
        });
      }

      getTeachersProfile().then(({ data }) =>
        setTeacher({
          ...data,
          classroomTeacher: data.advisingClass && data.advisingClass.year && data.advisingClass.letter ?
            (data.advisingClass.year + data.advisingClass.letter) : ''
        })
      )
    }
  }, [added]);
  
  return (
    <>
      {
        teacher &&
        <TeachersInfo teacher={teacher} user={user} loading={loading} setAdded={setAdded} />
      }
      {/* <Grid>
        <Grid.Column stretched width={12}>
          <TeachersInfo teachers={teachers} />
        </Grid.Column>
        <Grid.Column width={4} >
          <Menu fluid vertical pointing >
            <Menu.Item
              name='subjects'>
              <Header as='h4'>{dictionary?.SubjectsList[language]}</Header>
            </Menu.Item>
            <Menu.Item
              name='coupons'>
              {teachers && teachers.subjects.map((el) => <p>{el.nameEng}</p>)}
            </Menu.Item>
          </Menu>
        </Grid.Column>
      </Grid> */}
    </>
  );
};

export default TeachersProfile;
